import React from 'react';
import GenericModal from '@ui-components/Modal/GenericModal';
import { GenericTable } from '@ui-components/Table/GenericTable';
import { iamPermissionsColumns, IAMPermission } from './IAMPermisionsModalData';

interface IAMPermissionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  permissions: IAMPermission[];
  loading: boolean;
  error: string | null;
}

const IAMPermissionsModal: React.FC<IAMPermissionsModalProps> = ({ 
  isOpen, 
  onClose, 
  permissions,
  loading,
  error
}) => {
  return (
    <GenericModal
      isOpen={isOpen}
      onClose={onClose}
      title={<span className="text-xl font-bold">IAM Permissions</span>}
      size="lg"
      maxHeight="95vh"
      overflowY="auto"
      hideScrollbar={true}
    >
      <div className="mb-2 text-sm text-semantic-text-secondary">
        Showing IAM permissions for the cluster. Different permissions may indicate configuration issues.
      </div>
      {loading ? (
        <div className="flex justify-center items-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-4 border-gray-300 border-t-blue-500" />
        </div>
      ) : error ? (
        <div className="text-red-500 text-center py-4">{error}</div>
      ) : (
        <GenericTable
          columns={iamPermissionsColumns}
          data={permissions}
          tableClassName="bg-white"
          initialRowsPerPage={10}
          rowsPerPageOptions={[5, 10, 15]}
          width="100%"
          overflow="visible"
        />
      )}
    </GenericModal>
  );
};

export default IAMPermissionsModal;